<template>
  <div class="scroll">
    <card>
      <div v-for="f in staticFilters" :key="f.key">
        <label>{{ f.title }}</label>
        <radio-list
          :name="`${f.key}-filter`"
          v-model="params[f.key]"
          :items="f.items"
          @input="params['page'] = 1"
        />
      </div>
      <div v-if="params['day'] == 2">
        <selector
          :title="`Выберите учебный год (обязательно)`"
          :prefix="`season`"
          :modal="'season'"
          :selectKey="'title'"
          v-model="params['season']"
        />
      </div>
      <list
        v-if="init"
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :params="params"
        :isUpdate="true"
        :isAdd="false"
        :itemLink="itemLink"
        :setLink="setLink"
        :fields="fields"
        :searchDisable="true"
        @change="change"
        @changeFunction="changeFunction"
        v-model="val"
      />
    </card>
  </div>
</template>
<script>
export default {
  props: {
    group_id: {
      default: null,
    },
    discipline_id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `business/teacher_groups/${this.group_id}/journals/${this.discipline_id}/timetables`;
  },
  watch: {
    discipline_id(val) {
      this.init = false;
      this.itemLink = `business/teacher_groups/${this.group_id}/journals/${val}/timetables`;
      setTimeout(() => {
        this.init = true;
      }, 10);
    },
  },
  name: "timetables",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      season: null,
      staticFilters: [
        {
          title: "Показать дни:",
          key: "day",
          default: "1",
          items: [
            {
              id: 1,
              title: "Сегодняшние и прошедшие",
            },
            {
              id: 3,
              title: "Сегодняшние и будущие",
            },
            {
              id: 2,
              title: "фильтровать по учебному году",
            },
          ],
        },
      ],

      init: true,
      params: {},
      filters: [
        {
          key: "course",
          title: "Номер Класса",
        },
        {
          key: "discipline",
          title: "Дисциплина",
        },
      ],
      val: [],
      /**START ADD ITEM */
      modalCreate: "timetable",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_timetable",
      itemLink: "",
      setLink: "",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "date",
          title: "Дата урока",
          dateFormat: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "part",
          title: "Четверть",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "schedule",
          object: "position",
          title: "Номер урока",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "lessonplan",
          disableLink: true,
          title: "Плановый урок",
          object: "title",
          checkbox: false,
          full: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
.scroll {
  position: absolute;
  overflow: scroll;
  width: 100%;
  height: 100%;
}
</style>
